import { CountryCode, LanguageCode } from 'typescript/constants/localization';

/**
 * some endpoints require the url params to be sent in the query string to identify the order
 * @param countryCode
 * @param languageCode
 * @param orderNumber
 * @returns string - the query string
 */
export const _urlContext = ({
  countryCode,
  languageCode,
  orderNumber,
}: {
  countryCode: CountryCode;
  languageCode: LanguageCode;
  orderNumber: string;
}): string =>
  `?store_code=${countryCode}&language_code=${languageCode}&order_number=${orderNumber}`;
